export default "__VITE_ASSET__CXcenKIP__"